import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import classnames from 'classnames'

import { HeaderLink } from './HeaderLink'
import useHeader from '../../hooks/useHeader'

import styles from '../../styles/components/Header/HeaderItems.module.css'

const HeaderItems = props => {
  const header = useHeader()
  const itemsClassName = classnames(styles.list, {
    [styles.listOpen]: header.isMenuOpen
  })

  const renderItems = () =>
    props.allMarkdownRemark.nodes.map(({ frontmatter: data }) => (
      <li key={data.id}>
        <HeaderLink
          id={data.id}
          isFixed={header.isFixed}
          isActive={data.id === header.activeSection}
        >
          {data.menuTitle || data.title}
        </HeaderLink>
      </li>
    ))

  return <ul className={itemsClassName}>{renderItems()}</ul>
}

HeaderItems.propTypes = {
  allMarkdownRemark: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        frontmatter: PropTypes.shape({
          id: PropTypes.string.isRequired
        })
      })
    )
  })
}

const headerItemsQuery = graphql`
  query HeaderItemsQuery {
    allMarkdownRemark(
      sort: { fields: frontmatter___menuOrder }
      filter: { frontmatter: { id: { ne: "intro" } } }
    ) {
      nodes {
        frontmatter {
          id
          title
          menuTitle
        }
      }
    }
  }
`

export default props => (
  <StaticQuery query={headerItemsQuery} render={data => <HeaderItems {...data} {...props} />} />
)
